import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, { type WorkspaceAgentComposerSkillInsertSource } from './useTrackAgentComposerSkillAdded.meta';

export type { WorkspaceAgentComposerSkillInsertSource } from './useTrackAgentComposerSkillAdded.meta';

import { type SkillAnalyticsScope, type SkillAnalyticsType } from './skillAnalytics';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type UseTrackAgentComposerSkillAddedParams = {
  insert_source: WorkspaceAgentComposerSkillInsertSource;
  scope: SkillAnalyticsScope;
  skill_id: string;
  type: SkillAnalyticsType;
};

export const useTrackAgentComposerSkillAdded = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentComposerSkillAdded = useCallback(
    (params: UseTrackAgentComposerSkillAddedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentComposerSkillAdded };
};
